import { Outlet, createFileRoute } from "@tanstack/react-router";
import { SettingsNav } from "../../../components/settings-nav.js";

export const Route = createFileRoute("/_app/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <div style={{ display: "flex", gap: 24, maxWidth: 1080 }}>
      <SettingsNav />
      <main style={{ flex: 1, minWidth: 0 }}>
        <Outlet />
      </main>
    </div>
  );
}
